import { FormBlocker as FormBlockerProto } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useLogCashWebCdfEvent } from '@cash-web/shared-feature-analytics'
import { ModalPortal } from '@cash-web/shared-feature-modal'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { getBlockerActionPair } from '@cash-web/shared-flow-feature-main'
import { BlockerFlowInteractTapBlockerAction } from '@squareup/customer-data-events-web'

import { BlockerActionConfirmationDialogView } from '../BlockerActionConfirmationDialogView/BlockerActionConfirmationDialogView'
import { FormBlocker } from '../FormBlocker/FormBlocker'

export const BlockerActionView = () => {
  const flow = useFlowContext()
  const logCdfEvent = useLogCashWebCdfEvent()
  const blockerActionView = flow.active?.blockerActionView
  if (blockerActionView == null) {
    return null
  }
  const { key, action } = getBlockerActionPair(blockerActionView)
  if (action == null) {
    return null
  }

  switch (key) {
    case 'confirmation_dialog': {
      return (
        <ModalPortal>
          <BlockerActionConfirmationDialogView
            confirmation={action}
            onCancel={() => {
              logCdfEvent(
                BlockerFlowInteractTapBlockerAction({
                  flowToken: flow.active?.flowToken,
                  blockerId: flow.active?.blockerData?.id,
                  blockerAction: 'CONFIRMATION_DIALOG_FIRST',
                  actionText: action.cancel_button_text,
                  blockerType: flow.active?.blockerData?.type,
                  clientScenario: flow.active?.clientScenario,
                })
              )
              flow.closeBlockerAction()
            }}
            onConfirm={async () => {
              const { confirmation_dialog, ...finalAction } = blockerActionView
              await flow.executeBlockerAction(finalAction)
              flow.closeBlockerAction()
            }}
          />
        </ModalPortal>
      )
    }
    case 'show_overlay_screen_action': {
      const subformId = action.subform_id
      if (!subformId) {
        throw new Error(`Blocker - show_overlay_screen_action is missing subform_id: ${subformId}`)
      }

      const subform = (flow.active?.blockerData?.blocker as FormBlockerProto)?.subforms?.[subformId]
      if (!subform) {
        throw new Error(`Blocker - show_overlay_screen_action is missing subform data for subform id: ${subformId}`)
      }

      return (
        <ModalPortal
          closeButtonProps={{
            onClose: () => {
              flow.closeBlockerAction()
            },
          }}
        >
          <FormBlocker id={subformId} blocker={subform} />
        </ModalPortal>
      )
    }
    default: {
      throw Error(`Blocker - unimplemented blocker action view ${key}`)
    }
  }
}
